<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import { useI18n } from 'vue-i18n';
import { CONTENT_TYPES } from '../constants.js';
import { useMessageContext } from '../provider.js';
import { useInbox } from 'dashboard/composables/useInbox';

const { content, contentAttributes, contentType } = useMessageContext();
const { t } = useI18n();
const { isAWebWidgetInbox } = useInbox();

const formValues = computed(() => {
  if (contentType.value === CONTENT_TYPES.FORM) {
    const { items, submittedValues = [] } = contentAttributes.value;

    if (submittedValues.length) {
      return submittedValues.map(submittedValue => {
        const item = items.find(
          formItem => formItem.name === submittedValue.name
        );
        return {
          title: submittedValue.value,
          value: submittedValue.value,
          label: item?.label,
        };
      });
    }

    return [];
  }

  if (contentType.value === CONTENT_TYPES.INPUT_SELECT) {
    const [item] = contentAttributes.value?.submittedValues ?? [];
    if (!item) return [];

    return [
      {
        title: item.title,
        value: item.value,
        label: '',
      },
    ];
  }

  return [];
});

// GK-HUB: mensagem de menu/collectInput (ChatFlow) — mostra as opções oferecidas
// (só leitura, pro agente ver o que o cliente recebeu no canal dele). Só pra
// canais NÃO-widget: no widget a resposta volta via submittedValues na MESMA
// mensagem (formValues acima cobre isso, com NO_RESPONSE enquanto não responde);
// em WhatsApp/Telegram/Messenger a resposta chega como mensagem incoming
// SEPARADA — não existe sinal de "já respondido" nesta bolha, então as pills
// aqui são só informativas (não implicam "aguardando"), sem disputar o ciclo
// resposta/NO_RESPONSE que já existe pro widget.
const offeredItems = computed(() => {
  if (contentType.value !== CONTENT_TYPES.INPUT_SELECT) return [];
  if (formValues.value.length) return [];
  if (isAWebWidgetInbox.value) return [];

  return contentAttributes.value?.items ?? [];
});
</script>

<template>
  <BaseBubble class="px-4 py-3" data-bubble-name="csat">
    <span v-dompurify-html="content" :title="content" />
    <dl v-if="formValues.length" class="mt-4">
      <template v-for="item in formValues" :key="item.title">
        <dt class="text-n-slate-11 italic mt-2">
          {{ item.label || t('CONVERSATION.RESPONSE') }}
        </dt>
        <dd>{{ item.title }}</dd>
      </template>
    </dl>
    <!-- GK-HUB: opções oferecidas (ChatFlow menu/collectInput), só leitura -->
    <div v-else-if="offeredItems.length" class="flex flex-wrap gap-1.5 mt-3">
      <span
        v-for="item in offeredItems"
        :key="item.value"
        class="px-2 py-1 text-xs rounded-md outline-1 outline outline-n-container bg-n-solid-2 text-n-slate-12"
      >
        {{ item.title }}
      </span>
    </div>
    <div v-else-if="isAWebWidgetInbox" class="my-2 font-medium">
      {{ t('CONVERSATION.NO_RESPONSE') }}
    </div>
  </BaseBubble>
</template>
